var _Path, _Path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgHome(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M10.717 3.956a.313.313 0 00-.432 0l-7.192 6.87a.312.312 0 00-.096.226L2.996 17.5a1.25 1.25 0 001.25 1.25H8a.625.625 0 00.625-.625v-5.313a.313.313 0 01.312-.312h3.125a.313.313 0 01.313.313v5.312a.625.625 0 00.625.625h3.752a1.25 1.25 0 001.25-1.25v-6.448a.313.313 0 00-.096-.226l-7.19-6.87z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M19.676 9.537l-2.922-2.795V2.5a.625.625 0 00-.625-.625h-1.875a.625.625 0 00-.625.625v1.25l-2.262-2.163a1.216 1.216 0 00-.867-.337c-.34 0-.653.123-.865.337l-8.309 7.95a.637.637 0 00-.052.873.625.625 0 00.905.042l8.106-7.746a.312.312 0 01.432 0l8.106 7.746a.625.625 0 00.883-.018.64.64 0 00-.03-.897z"
  })));
}
export default SvgHome;